import { list } from './mockDb.js';
import { axios } from '@/main.js';
import { reactive } from 'vue';
import { emptyBase } from './mockDb.js';
export const getMainPage = async () => {
  return await getMainPageDev();
};

async function getMainPageDev() {
  let response = await axios.get(
    `fleetsAllByUser/${JSON.parse(localStorage.getItem('userInfo')).uid}`,
    {},
  );
  return response.data.fleets;
  // return { list };
}

export async function addNewVehicle(id, assetName, manual) {
  // let base = this.cloneObj(emptyBase);
  if (manual == false) {
    let units = JSON.parse(localStorage.getItem('unitSelection'));
    let result = units.find((obj) => obj.assetId === id[0]);
    base.fleetInfo.plate = result.assetName;
    base.fleetInfo.assetId = result.assetId;
  }
  if (manual == true) {
    base.fleetInfo.plate = assetName;
    base.fleetInfo.assetId = id;
  }

  let response = await axios.post('fleets/submit', {
    assetId: id,
    userInfo: JSON.parse(localStorage.getItem('userInfo')),
  });
  if (response.status == 200 && response.data.success) {
  }
}

export const getDetails = async (id) => {
  return await getFleetDev(id);
};
async function getFleetDev(id) {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await axios.get(`fleetsSingle/${id}`, {});
      if (response.status == 200 && response.data.success) {
        let data = response.data;
        for (let key in data.fleetDetails) {
          data.fleetDetails[key] = isJsonString(data.fleetDetails[key]);
        }
        resolve(data);
      }
    } catch (error) {
      reject(error);
    }
  });
}
function isJsonString(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

export const template = {
  notification: {
    mode: [],
    type: '',
    detail: '',
    remark: '',
  },
  documents: {
    cost: 0,
    date: '',
    type: '',
    remark: '',
    mileage: '',
    documents: [],
  },
  // remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
  engine: {
    cost: 0,
    date: '',
    type: '',
    remark: '',
    mileage: '',
    mileageOnce: null,
    mileageOnceType: 'Exact',
    subtype: '',
    documents: [],
  },
  history: {
    cost: 0,
    date: '',
    type: '',
    remark: '',
    documents: [],
  },
  tyre: {
    brand: '',
    model: '',
    pincode: '',
    remarks: '',
    reminders: [],
    purchaseData: '',
    purchaseDate: '',
    purchasePrice: 0,
    selectedIndex: 0,
    purchaseStatus: 'CELUP',
  },
  tyreReminders: {
    cost: 0,
    date: '',
    remark: '',
    mileage: '',
    notif: [],
    type: '',
  },
};

export const store = reactive({
  userInfo: JSON.parse(localStorage.getItem('userInfo')),
  state: {},
  edited: false,
  fetching: false,
  list: null,
  unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
  selected: null,
  data: null,
  addRow(state, t) {
    state.push(this.cloneObj(t));
  },
  removeRow(state, i) {
    state.splice(i, 1);
  },
  async getData(fleetId) {
    this.fetching = true;
    this.edited = false;
    this.data = await getDetails(fleetId);
    this.state = await this.transformData();
    this.fetching = false;
    this.edited = false;
  },
  async updateData(fleetId, el) {
    let base = this.reTransformData();
    await axios.patch(`fleetsSingle/${fleetId}`, base);
    await this.getData(fleetId);
    el.__vue__.$vs.notify({
      title: 'Success',
      text: 'Data has been saved',
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'success',
    });
    this.edited = false;
  },
  async transformData() {
    return new Promise((resolve) => {
      let v2 = {};
      let fleet = this.data.fleetDetails;
      // console.log('transform', v2);
      v2.profile = this.cloneObj(fleet.fleetInfo);
      if (v2.profile.class && v2.profile.class.text) {
        v2.profile.class = v2.profile.class.text;
      }
      v2.engine = this.cloneObj(fleet.fleetMaintenance);
      v2.documents = this.cloneObj(fleet.fleetAlarm);
      let config = this.cloneObj(fleet.fleetConfig);
      v2.config = {
        tyre: {
          front: {
            count: Number(config.frontTire),
            single: config.frontTirePair == 'Single' ? true : false,
          },
          middle: {
            count: Number(config.middleTire),
            single: config.middleTirePair == 'Single' ? true : false,
          },
          back: {
            count: Number(config.backTire),
            single: config.backTirePair == 'Single' ? true : false,
          },
        },
        fuel: {
          count: Number(config.tankCount),
          tanks: this.getConfigTanks(config),
        },
        mileage: config.mileage,
        trackers: {
          fuelSensor: config.fuelSensor,
          baseTracker: config.baseTracker,
          temperatureSensor: config.temperatureSensor,
        },
      };

      v2.notification = {
        channel: this.cloneObj(fleet.fleetNotification),
        config: {
          engine: [...fleet.fleetNotificationConfig],
          document: [...fleet.docNotificationConfig],
          tire: [...fleet.tireNotificationConfig],
        },
      };
      v2.tyre = this.getTyres(this.cloneObj(fleet.fleetTireListing));

      v2.history = this.cloneObj(fleet.fleetRecordHistory);

      resolve(v2);
    });
  },
  reTransformData() {
    let details = {};
    details.fleetInfo = this.state.profile;
    if (details.fleetInfo.class && details.fleetInfo.class.trim() != '') {
      details.fleetInfo.class = {
        text: details.fleetInfo.class,
        value: details.fleetInfo.class.split(' ')[1],
      };
    }
    details.fleetMaintenance = this.state.engine;
    details.fleetAlarm = this.state.documents;

    details.fleetConfig = {
      frontTire: this.state.config.tyre.front.count,
      frontTirePair: this.state.config.tyre.front.single ? 'Single' : 'Pair',
      middleTire: this.state.config.tyre.middle.count,
      middleTirePair: this.state.config.tyre.middle.single ? 'Single' : 'Pair',
      backTire: this.state.config.tyre.back.count,
      backTirePair: this.state.config.tyre.back.single ? 'Single' : 'Pair',

      mileage: this.state.config.mileage,
      tankCount: this.state.config.fuel.count,
      ...this.getOriginalTanks(),
      fuelSensor: this.state.config.fuelSensor,
      baseTracker: this.state.config.baseTracker,
      temperatureSensor: this.state.config.temperatureSensor,
    };

    details.fleetNotification = this.state.notification.channel;

    details.fleetNotificationConfig = this.state.notification.config.engine;
    details.docNotificationConfig = this.state.notification.config.document;
    details.tireNotificationConfig = this.state.notification.config.tire;

    details.fleetTireListing = this.getOriginalTyres();

    details.fleetRecordHistory = this.data.fleetDetails.fleetRecordHistory;
    return details;
  },
  cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  getConfigTanks(obj) {
    return Object.entries(obj)
      .filter(([key]) => key.startsWith('tank') && key !== 'tankCount')
      .map(([, value]) => value);
  },
  getOriginalTanks() {
    let obj = {};
    this.state.config.fuel.tanks.forEach((e, i) => {
      obj[`tank${i}`] = e;
    });
    return obj;
  },
  getTyres(data) {
    return data.reduce((acc, item) => {
      acc[item.position] = item;
      return acc;
    }, {});
  },
  getOriginalTyres() {
    let arr = [];
    for (const key in this.state.tyre) {
      arr.push(this.state.tyre[key]);
    }
    return arr;
  },
  async removeFleet(fleetId, el) {
    await axios.delete(`fleetsSingle/${fleetId}`, {});
    // this.list = null;
    await this.getMainPageDev();
    el.__vue__.$vs.notify({
      title: 'Success',
      text: 'Vehicle has been removed',
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'success',
    });
  },
  async getMainPageDev() {
    let response = await axios.get(`fleetsAllByUser/${this.userInfo.uid}`, {});
    this.list = response.data.fleets;
    // console.log(this.list);
    // return { list };
  },
  async addNewVehicle(id) {
    let base = this.cloneObj(emptyBase);
    let units = this.unitSelection;
    let result = units.find((obj) => obj.assetId === id);
    base.fleetInfo.plate = result.assetName;
    base.fleetInfo.assetId = result.assetId;
    let response = await axios.post('fleets/submit', {
      assetId: base.fleetInfo.assetId,
      userInfo: this.userInfo,
      ...base,
    });
    if (response.status == 200 && response.data.success) {
      await this.getMainPageDev();
      return 'success';
    } else {
      return response;
    }
  },
  addNewTyre(v) {
    let obj = { [v]: this.cloneObj(template.tyre), ...this.state.tyre };
    obj[v].position = v;
    this.state.tyre = obj;
  },
  removeTyre(v) {
    let obj = { ...this.state.tyre };
    delete obj[v];
    this.state.tyre = obj;
  },
});
